import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube, Linkedin, Laptop } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { BrushUnderline } from "@/components/public/Brush";

export default function Footer() {
  const { settings, categories } = useSettings();
  const social = settings.social || {};
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="relative border-t border-ink-600 texture-concrete mt-28 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-5 lg:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="relative inline-block">
              <h2 className="font-poster text-white leading-[0.86] text-6xl sm:text-7xl lg:text-8xl">
                LUCRATIVE<br /><span className="relative inline-block text-brand">LAPTOP
                  <BrushUnderline className="absolute left-0 -bottom-3 w-full h-4 text-brand" />
                </span>
              </h2>
            </div>
            <p className="font-hand text-brand text-2xl mt-8">Good ideas deserve a shot.</p>
            <div className="flex items-center gap-3 mt-7">
              {social.instagram && <a href={social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram" className="w-11 h-11 border border-ink-600 flex items-center justify-center text-white/80 hover:text-brand hover:border-brand transition-colors"><Instagram size={17} /></a>}
              {social.twitter && <a href={social.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter" data-testid="social-twitter" className="w-11 h-11 border border-ink-600 flex items-center justify-center text-white/80 hover:text-brand hover:border-brand transition-colors"><Twitter size={17} /></a>}
              {social.youtube && <a href={social.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube" data-testid="social-youtube" className="w-11 h-11 border border-ink-600 flex items-center justify-center text-white/80 hover:text-brand hover:border-brand transition-colors"><Youtube size={17} /></a>}
              {social.linkedin && <a href={social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="social-linkedin" className="w-11 h-11 border border-ink-600 flex items-center justify-center text-white/80 hover:text-brand hover:border-brand transition-colors"><Linkedin size={17} /></a>}
            </div>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <div className="label-mono mb-5">// Sections</div>
            <ul className="space-y-3">
              {categories.map((c) => <li key={c.slug}><Link to={`/category/${c.slug}`} className="font-cond uppercase tracking-wide text-white/80 hover:text-brand transition-colors text-lg">{c.name}</Link></li>)}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="label-mono mb-5">// More</div>
            <ul className="space-y-3">
              <li><Link to="/about" className="font-cond uppercase tracking-wide text-white/80 hover:text-brand transition-colors text-lg">About</Link></li>
              <li><Link to="/start-here" className="font-cond uppercase tracking-wide text-white/80 hover:text-brand transition-colors text-lg">Start Here</Link></li>
              <li><Link to="/search" className="font-cond uppercase tracking-wide text-white/80 hover:text-brand transition-colors text-lg">Search</Link></li>
              <li><a href={`${process.env.REACT_APP_BACKEND_URL}/api/rss.xml`} className="font-cond uppercase tracking-wide text-white/80 hover:text-brand transition-colors text-lg">RSS Feed</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-ink-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-white/50"><Laptop size={16} className="text-brand" /><p className="text-xs font-mono-label">© {year} LUCRATIVE LAPTOP</p></div>
          <div className="flex items-center gap-5 text-xs font-cond uppercase tracking-wider text-white/50">
            <span className="hover:text-white/80 cursor-default">Privacy</span>
            <span className="hover:text-white/80 cursor-default">Terms</span>
            <span className="hover:text-white/80 cursor-default">Affiliate Disclosure</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
